import React from "react";
import { useLocation } from "react-router";
import { Alert } from "mesh-component-library";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";
import { useLocale } from "../../contexts/LocaleContext";

type OvercostWarningProps = {
  amount: string;
};

export const OvercostWarning = ({ amount }: OvercostWarningProps) => {
  const getTranslatedText = useLocale();
  const location = useLocation();

  const isFrenchCost = location.pathname.includes("fr_CA");
  amount = amount.toString();
  const cost = isFrenchCost ? amount.replace(".", ",") : amount;

  return (
    <div className="c-container-warning">
      <Alert variant="caution">
        <b>{getTranslatedText(TRANSLATION_CONSTANTS.OVERCOST_WARNING).replace("{{price}}", `${cost}`)}</b>
      </Alert>
    </div>
  );
};

const primaryLookupMessage = (noBenefitsLookType: string) => {
  switch (noBenefitsLookType) {
    case "firstNameLastNameZip":
      return TRANSLATION_CONSTANTS.FN_LN_ZIP_LOOKUP_FAILURE;
    case "LastNameStateZip":
      return TRANSLATION_CONSTANTS.NAME_STATE_ZIP_LOOKUP_FAILURE;
    case "phoneNumber":
    case "phoneNumberLastNameLookup":
      return TRANSLATION_CONSTANTS.PHONE_LOOKUP_FAILURE;
    default:
      return "";
  }
};

export const PrimaryLookupFailure = ({ noBenefitsLookType = "" }) => {
  const getTranslatedText = useLocale();
  const warningMessage = primaryLookupMessage(noBenefitsLookType);
  return (
    !!warningMessage && (
      <div id="primary-lookup-failure-message" className="c-container-warning">
        <Alert variant="caution">
          <b>{getTranslatedText(warningMessage)}</b>
        </Alert>
      </div>
    )
  );
};
